import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from '@tanstack/react-router';
import { NavigationItem } from './interfaces';
import { useStyles } from './styles';

export const MenuItem = ({
  item: { url, title, icon, id },
  disabled,
}: {
  item: NavigationItem;
  disabled?: boolean;
}) => {
  const { cx, classes } = useStyles();
  return (
    <Link
      activeOptions={{ exact: false }}
      component={RouterLink}
      to={url}
      key={id}
      className={cx(classes.navLink)}
      data-e2e={`LEFT_SIDE_NAVIGATION__${id}__BUTTON`}
      disabled={disabled}
    >
      {icon}
      {typeof title === 'string' ? <Typography>{title}</Typography> : title}
    </Link>
  );
};
